import { Injectable } from '@angular/core';

export interface CondicaoPagamentoPrazoExtractor {
    prazo: number;
}

@Injectable({
    providedIn: 'root'
})
export class CondicaoPagamentoPrazoUtilsService {

    /** Extrai os prazos informados para uma string formatada */
    extractPrazosToString(entities: CondicaoPagamentoPrazoExtractor[]): string {
        if (!entities) {
            return '';
        }

        let prazos = '';
        entities.forEach(entity => {
            if (prazos !== '') {
                prazos += '/';
            }
            if (entity.prazo) {
                prazos += entity.prazo.toString();
            }
        });

        if (prazos !== '') {
            prazos += ' dias';
        }

        return prazos;
    }
}
